import React, {useEffect, useState} from "react";
import "./Faq.scss";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";
import {useHistory} from "react-router";
import {getFaq_api, MessageData, MessageSeen, TopicData} from "./FaqServices";
import {Collapse} from 'react-collapse';
import moment from "moment-jalaali";

import { PlusSquareOutlined,MinusSquareOutlined} from '@ant-design/icons';
import {useParams} from "react-router-dom";



const ConvertToJalali = (date) =>{
    // console.log("Data : ",date)
    if(date){
        return  moment.utc(date.split('+')[0]).format('jYYYY-jMM-jDD HH:mm');
    }
    return ""
}

function Faq() {

    //hooks
    let history = useHistory();
    const { merchantId } = useParams();

    //states
    const [last,setLast] = useState([])
    const [messages,setMessages] = useState([])
    const [faq,set_faq] = useState([])

    // const params = {
    //     slidesPerView: 3,
    //     spaceBetween: 5,
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true
    //     }
    // }

    useEffect(()=>{
        // getLast().then();
        // getMessages().then();
        getFaq().then();
    },[])

    const getLast = async () =>{
        const topics = await TopicData();
        setLast(topics.data)
        // console.log("topics : ", topics);
    }

    const getMessages = async () =>{
        const messages = await MessageData();
        setMessages(messages.data.results)
        // console.log("messages : ", messages);
    }

    const getFaq = async () =>{
        const messages = await getFaq_api(merchantId);
        set_faq(messages.data.results)
        // console.log("messages : ", messages);
    }

    const sliderCalc = (count)=>{
        if(count===1){return 1}
        if(count===2){return 2}
        if(count>2){return 3}
    }


    const NotifCard =  ({item})=>{

        const [open,set_open] = useState(false)

        return(
            <div className="faq-item" onClick={e=>{set_open(!open)}}>
                <div className="question-sec">
                    <span>{item?.question_body}</span>
                    {open?<MinusSquareOutlined />:<PlusSquareOutlined />}
                </div>

                <Collapse isOpened={open}>
                    <div className="answer-sec">
                        {item?.answers?.map(ans=>{
                            return(
                                <>
                                    <p>{ans.answer_body}</p>
                                </>
                            )
                        })}

                    </div>
                </Collapse>
            </div>
        )
    }


    return(
        <div className="notif-container">
            <div className="customer-header">
                <span>سوالات متداول</span>
                <i onClick={()=>{
                    // history.goBack();
                    history.push("/home")
                }}
                   className="fa fa-arrow-right"></i>
            </div>

            {/*<div className="notif-last-visit">*/}
            {/*    <div className="notif-last-visit-titre">*/}
            {/*        <span>پیام ها</span>*/}
            {/*    </div>*/}

            {/*    <div className="notif-last-visit-list">*/}


            {/*        {last.length>0?<SwiperId { ...{*/}
            {/*            slidesPerView: sliderCalc(last.length),*/}
            {/*            spaceBetween: 5,*/}
            {/*            pagination: {*/}
            {/*                el: '.swiper-pagination',*/}
            {/*                clickable: true*/}
            {/*            }*/}
            {/*        }}>*/}
            {/*            {last && last.map(item=>{*/}
            {/*                return(*/}

            {/*                    <div className="notif-last-visit-item" onClick={()=>{*/}
            {/*                        let merchantId = item.topic.split(":")[2];*/}
            {/*                        history.push(`/chat/${item.topic}`,*/}
            {/*                            {merchant: {uid:merchantId, name:item.title, topic:item.topic}*/}
            {/*                            })*/}
            {/*                    }}>*/}
            {/*                        <img src={item.image} />*/}
            {/*                        <span>{item.title}</span>*/}
            {/*                    </div>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*            /!*<div className="notif-last-visit-message">*!/*/}
            {/*            /!*    <div className="plus-wrapper">*!/*/}
            {/*            /!*        <img src="/svg/pluse_icon.svg" alt="plus"/>*!/*/}
            {/*            /!*    </div>*!/*/}
            {/*            /!*    <span>پیام جدید</span>*!/*/}
            {/*            /!*</div>*!/*/}
            {/*        </SwiperId>:null}*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="notif-list-sec">
                <div className="notif-last-visit-titre">
                    <span>پرسش ها</span>
                </div>

                <div className="notif-list">

                    {faq && faq.map(mes=>{
                        return(
                            <NotifCard item={mes}/>
                        )
                    })}


                </div>



            </div>


        </div>
    )
}


export {Faq};
